import BaseContentLoader, {
  type IContentLoaderProps,
} from 'react-content-loader';

import { colors } from '../styles/colors';

/**
 * Height and width is required otherwise the viewbox will be set to the default values setted in the library.
 * We set the viewbox and viewport to the same values so there will be no scaling.
 */
type ContentLoaderProps = Pick<
  IContentLoaderProps,
  'children' | 'className'
> & {
  height?: number | string;
  width?: number | string;
  className?: string;
};

const ContentLoader = (props: ContentLoaderProps) => {
  const { children, height, width } = props;

  return (
    <div data-testid='content-loader'>
      <BaseContentLoader
        style={{ width, height }}
        {...props}
        speed={2}
        primaryColor={colors.gray.lightest}
        secondaryColor={colors.gray.light}
      >
        {children}
      </BaseContentLoader>
    </div>
  );
};

export default ContentLoader;
